import { render } from "./saleStock.vue?vue&type=template&id=18fb0e28&scoped=true"
import script from "./saleStock.vue?vue&type=script&lang=js"
export * from "./saleStock.vue?vue&type=script&lang=js"

import "./saleStock.vue?vue&type=style&index=0&id=18fb0e28&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18fb0e28"]])

export default __exports__